// src/services/dashboardService.js
import api from "./api";

const DashboardService = {
  getDashboardSummary: async ({ companyId, employeeId, roleId, projectId, projectCategoryId, date }) => {
    let url = `/dashboard/summary?companyId=${companyId}&employeeId=${employeeId}&roleId=${roleId}`;

    if (projectId) {
      url += `&projectId=${projectId}`;
    }

    if (projectCategoryId) {
      url += `&projectCategoryId=${projectCategoryId}`;
    }

    if (date) {
      url += `&date=${date}`;
    }

    const res = await api.get(url);
    return res.data;
  },
};

export default DashboardService;
